// import _ from 'lodash'

export const covid19Store = {
  namespaced: true,
  state: {
    countrymapIconOffset: {
      'United States': [{ x: 80, y: -70 }, { x: 50, y: 50 }],
      'Chile': [{ x: 40, y: 0 }],
      'Ecuador': [{ x: 10, y: 0 }],
      'Portugal': [{ x: 27, y: -10 }],
      'Netherlands': [{ x: 95, y: -61 }],
      'France': [{ x: -60, y: -86 }],
      'Spain': [{ x: 10, y: -10 }],
      'South Africa': [{ x: -10, y: -10 }],
      'Norway': [{ x: -10, y: 75 }],
      'Canada': [{ x: -40, y: 75 }],
      'New Zealand': [{ x: 0, y: -10 }, { x: -26, y: 34 }],
      'Australia': [{ x: 0, y: -30 }]
    },
    attribute_map: {
      'A_01': ['A_01', 'SA_01_01', 'SA_01_02', 'SA_01_03', 'SA_01_04'],
      'SA_01_01': ['SA_01_01'],
      'SA_01_02': ['SA_01_02'],
      'SA_01_03': ['SA_01_03'],
      'SA_01_04': ['SA_01_04'],
      'A_02': [
        'SA_02_01', 'SA_02_02', 'SA_02_03',
        'SC_02_02_a', 'SC_02_02_b', 'SC_02_02_c', 'SC_02_02_d', 'SC_02_02_e',
        'SC_02_03_a', 'SC_02_03_b', 'SC_02_03_c'
      ],
      'SA_02_01': ['SA_02_01'],
      'SA_02_02': ['SA_02_02', 'SC_02_02_a', 'SC_02_02_b', 'SC_02_02_c', 'SC_02_02_d', 'SC_02_02_e'],
      'SA_02_03': ['SA_02_03', 'SC_02_03_a', 'SC_02_03_b', 'SC_02_03_c'],
      'SC_02_02_a': ['SC_02_02_a'],
      'SC_02_02_b': ['SC_02_02_b'],
      'SC_02_02_c': ['SC_02_02_c'],
      'SC_02_02_d': ['SC_02_02_d'],
      'SC_02_02_e': ['SC_02_02_e'],
      'SC_02_03_a': ['SC_02_03_a'],
      'SC_02_03_b': ['SC_02_03_b'],
      'SC_02_03_c': ['SC_02_03_c'],
      'A_03': ['A_03', 'SA_03_01', 'SA_03_02', 'SA_03_03'],
      'SA_03_01': ['SA_03_01'],
      'SA_03_02': ['SA_03_02'],
      'SA_03_03': ['SA_03_03'],
      'A_04': ['A_04', 'SA_04_01', 'SA_04_02'],
      'SA_04_01': ['SA_04_01'],
      'SA_04_02': ['SA_04_02'],
      'A_05': ['A_05', 'SA_05_01', 'SA_05_02', 'SA_05_03', 'SA_05_04'],
      'SA_05_01': ['SA_05_01'],
      'SA_05_02': ['SA_05_02'],
      'SA_05_03': ['SA_05_03'],
      'SA_05_04': ['SA_05_04']
    },

    /**
     * Has user set the covid19 filter on/off
     */
    is_enabled: true,

    /**
     * The countries information
     * @type {Obj}
     */
    all: {},

    /**
     * Country information
     * @type {Obj}
     */
    countries: {},

    /**
     * The last time this information was updated
     */
    last_updated: false,

    /**
     * Tells if the filter is available for the current page or not
     */
    filter_available: false
  },

  getters: {
    /**
     * Return a countries information by country_code
     * @param  {object} country_code   The country code
     * @return {Boolean}
     */
    getCountry: (state, getters) => (countryCode) => {
      return state.all[countryCode]
    },
    /**
     * Return the last updated date
     * @param  {object} country_code   The country code
     * @return {Boolean}
     */
    getLastUpdated: (state, getters) => (countryCode) => {
      if (countryCode !== undefined) {
        let country = getters.getCountry(countryCode)
        if (country && country.last_updated) {
          return country.last_updated
        }
      }
      return state.all.last_updated
    },

    countryType: (state, getters) => (countryCode) => {
      let country = getters.getCountry(countryCode)
      return country && country.country_type ? country.country_type : false
    },

    countryAttributeType: (state, getters) => (countryCode, attributeKey) => {
      let country = getters.getCountry(countryCode)
      return country && country.attr && country.attr[attributeKey] ? country.attr[attributeKey] : false
    }
  },
  mutations: {},
  actions: {}
}



// WEBPACK FOOTER //
// ./src/stores/covid19Store.js